import { IconButton } from "@mui/material";
import BugReportIcon from '@mui/icons-material/BugReport';

import { ILogEntries } from "../../Lib/Log/types";
import { useAction } from "../../Lib/Actions/useAction";
import { IInstantNotifier } from "../../Lib/Notifier/types";
import LogViewPopup from "./LogViewerPopup";


interface InitialisingLogButtonProps {
    log: ILogEntries;
    notifier?: IInstantNotifier;
};

const InitialisingLogButton = (props: InitialisingLogButtonProps) => {

    const viewLogAction = useAction<void, void>();

    return (
        <>
            <IconButton 
                color="secondary" 
                onClick={() => viewLogAction.start()}
                sx={{ position: 'absolute', top: 0, right: 0 }}
            >
                <BugReportIcon />
            </IconButton>

            <LogViewPopup action={viewLogAction} log={props.log} />
        </>
    );
};

export default InitialisingLogButton;